module.exports = __webpack_public_path__ + "img/s3.e9b9ad3.png";